import { AlgoliaSearchClientRepository } from "@data/repositories/index";
import { GetChartClientsUseCase } from "@useCases/index";
import { datetimeHelper } from "@helpers/datetime";
import { algoliaIndex } from "@data/algolia/config";
import { Filter } from "@domain/models/Filters";
import userStore from "@data/stores/user";

export default function useChart() {
  const getChartClients = async (filters: Filter[]) => {
    const validFilters = filters.filter((x) => x.type !== "date");

    const interval = datetimeHelper.getMillisecondsForYearBackwards();

    const useCase = new GetChartClientsUseCase(
      userStore.getState(),
      new AlgoliaSearchClientRepository(algoliaIndex)
    );

    return useCase.execute({ filters: validFilters, monthsInterval: interval });
  };
  return {
    getChartClients,
  };
}
